import Vue from "vue";
import Const from "../services/Constants";

const promptForLink = async () => {   
   var c = new Const();
   return await Vue.prototype
      .$swal({
         icon: "warning",
         title: "Oops!",
         text: "Please enter a valid appointment link",
         input: "text",
         inputPlaceholder: "Link not valid! (A link may start with MLT, EXT...)",
         showCloseButton: false,
         showCancelButton: true,
         allowOutsideClick: false,
         allowEscapeKey: false,
         confirmButtonText: 'Ok',
         cancelButtonText: 'Cancel',
         customClass: {
            confirmButton: 'dialogBtn',
            cancelButton: 'dialogBtn'
         },
         inputValidator: value => {
            return new Promise(resolve => {
               if (!value || value.length == 0) {
                  resolve("A link is required! ");
                  return;
               }

               if (value.toString().toLowerCase().startsWith('http') || 
                   value.toString().includes("/")) {
                  resolve("Your link is invalid!  You link may start with MLT, EXT, USR, MD...");
               } else {
                  Vue.prototype.$user
                  .validateLink(value)
                  .then(result => {
                     if (result.isValid) {
                        resolve();
                     } else {                
                        //link is invalid.
                        switch (result.failureReasonCode) {
                           case c.LINK_FAILCODE_SCHED_INACTIVE:
                              resolve("Your schedule link is inactive!  Ask your recruiter to give you a new link.");
                              break;
                           case c.LINK_FAILCODE_APPT_LINK_DELETED:
                              resolve ("Your link is expired.  Ask your recruiter to give you a new link.")
                              break;
                           case c.LINK_FAILCODE_APPT_LINK_INVALID:
                              resolve ("Your link is invalid.  Ask your recruiter to give you a new link.")
                              break;
                           case c.LINK_FAILCODE_MD_LINK_INVALID: 
                           resolve ("Your Marketing Director link is invalid.  Ask ManhattanLife Marketing Department to give you a new link.")
                              break;
                           case c.LINK_FAILCODE_AGENT_LINK_INVALID:
                              resolve ("Your Agent link is invalid.  Ask ManhattanLife Marketing Department or your recruiter to give you a new link.")
                              break;
                           case c.LINK_FAILCODE_UNKNOWN_INVALID_LINK:
                              resolve ("Your link is invalid and the reason is unknown.  Ask ManhattanLife Marketing Department to give you a new link and let the Tech Support know this issue occurred.")
                              break;
                        }                        
                     }
                  })
                  .catch(err => {
                     resolve("Error occurred validating link!");
                  });
               }
            });
         }
      })
      .then(result => {
         return result.value;
      });
};

// if link is bad prompt for a good one
export async function checkOrGetGoodLink(appointmentLink = "") {
   try {
      var good = false;
      var res = await Vue.prototype.$user.validateLink(appointmentLink);
      if (res != null) {
         good = res.isValid;
      }
      const linkIsGood =
         appointmentLink && good;
      const goodLink = linkIsGood ? appointmentLink : await promptForLink();
      return goodLink == undefined ? null : goodLink;
   } catch (err) {
      console.log("Error validating link: ", err);
      throw err;
   }
}
